import { render, staticRenderFns } from "./PapelConsumo.vue?vue&type=template&id=98b96670&"
import script from "./PapelConsumo.vue?vue&type=script&lang=js&"
export * from "./PapelConsumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports